/**
 * api/society.api.js — Society & member API calls
 */
import client from './client';

export const getSocieties   = ()                           => client.get('/societies');
export const getSociety     = (id)                         => client.get(`/societies/${id}`);
export const createSociety  = (data)                       => client.post('/societies', data);
export const updateSociety  = (id, data)                   => client.put(`/societies/${id}`, data);
export const deleteSociety  = (id)                         => client.delete(`/societies/${id}`);

// Members
export const addMember      = (societyId, data)            => client.post(`/societies/${societyId}/members`, data);
export const updateMember   = (societyId, memberId, data)  => client.put(`/societies/${societyId}/members/${memberId}`, data);
export const removeMember   = (societyId, memberId)        => client.delete(`/societies/${societyId}/members/${memberId}`);

// Modules
export const getModules     = ()                           => client.get('/modules');
